import axios from 'axios'
import AuthToken from '@/auth/auth-token'

class KeyValue {
  constructor () {
    const keyValue = axios.create({
      baseURL: process.env.BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.keyValue = keyValue

    keyValue.interceptors.response.use(this.handleSuccess)
  }

  handleSuccess (response) {
    let data = response.data

    return data
  }

  // New key_value endpoints
  async getByKeyID (keyID, limit = 50, offset = 0) {
    await AuthToken.setAuth(this.keyValue)
    return this.keyValue({
      url: `/key_values/${keyID}`,
      method: 'GET',
      params: { limit, offset }
    })
  }
}

export default new KeyValue()



// WEBPACK FOOTER //
// ./src/api/key_value.js